<template>
  <div
    class="mt-3 mb-3 w-full h-[196px] flex flex-col justify-center items-center bg-[#d6f1fa] gap-2 border-2 border-dashed border-secondary-300 font-editor"
    data-testid="block-placeholder"
  >
    <div class="font-bold text-black text-lg">Block will be placed here</div>
    <div class="!bg-transparent typography-text-sm">Choose one from templates</div>
  </div>
</template>
